import { IconBase } from './IconBase'

type IconAppleProps = React.ComponentProps<'svg'>

export const IconApple = (props: IconAppleProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <g clipPath="url(#a)">
        <path
          d="M16.25 22c-.889 0-1.5-.288-2.04-.543-.52-.245-.97-.457-1.71-.457s-1.19.212-1.71.457c-.54.255-1.151.543-2.04.543C6.587 22 3 17.036 3 11.75 3 8.245 5.416 5.5 8.5 5.5c1.014 0 1.63.29 2.173.547.516.243.962.453 1.827.453s1.311-.21 1.827-.453c.543-.256 1.16-.547 2.173-.547 1.332 0 2.517.491 3.521 1.46a.75.75 0 0 1-.144 1.189c-1.158.673-1.877 2.1-1.877 3.726 0 1.83 1.002 3.405 2.493 3.916a.748.748 0 0 1 .451.993C19.731 19.758 17.712 22 16.25 22Zm-3.5-17a.75.75 0 0 1-.747-.818 4.821 4.821 0 0 1 1.296-2.691C14.377.39 15.425.064 15.541.03a.75.75 0 0 1 .951.826c-.017.12-.194 1.218-1.116 2.45-.986 1.317-2.395 1.66-2.454 1.674a.744.744 0 0 1-.172.02Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </IconBase>
  )
}
